/**
 * The width the dock opens at on a display with room for more. `agentChat.dockWidthPx` is not persisted, so
 * every reload starts from the default — which on a 3440px ultrawide meant dragging a 392px dock out again
 * every session. Its own file, read only by the slice's initial state, so it can be dropped without touching
 * the geometry in `dock-metrics.ts`.
 */

import { DOCK_DEFAULT_WIDTH_PX } from "./dock-metrics"

/** At or below this the default is untouched: this widens the dock only where the width actually exists. */
export const DEFAULT_WIDTH_REFERENCE_VIEWPORT_PX = 1920

/**
 * The same SHARE of the display that 392px is of a 1920px screen (~20.4%), which is comfortably inside the 45%
 * ceiling at every width, so a wider default can never open the dock already pinned at its maximum.
 */
export function dockDefaultWidth(viewportWidth: number): number {
  if (viewportWidth <= DEFAULT_WIDTH_REFERENCE_VIEWPORT_PX) return DOCK_DEFAULT_WIDTH_PX
  return Math.round(viewportWidth * (DOCK_DEFAULT_WIDTH_PX / DEFAULT_WIDTH_REFERENCE_VIEWPORT_PX))
}

/**
 * Read once, when the store is built. A later resize needs no correction: this number is only the middle term of
 * `dockWidthCss`'s clamp, whose bounds the browser re-resolves against the live viewport at paint time.
 */
export function initialDockWidth(): number {
  return typeof window === "undefined" ? DOCK_DEFAULT_WIDTH_PX : dockDefaultWidth(window.innerWidth)
}
